<template>
  <div class="fare-options-container p-4" >
    <h2 class="is-size-4 ml-3">Select a fare option for this flight:</h2>

    <div class="columns is-mobile mt-4">
      <!-- AIRLINE LOGO -->
      <div class="column is-narrow has-text-centered wrap">
        <div class="mt-1 airlineLogo">
          <img
            width="20"
            :src="$helpers.airlineLogo(solution.airlineCode, 20, 20)"
          />
        </div>
      </div>
      <!-- FROM-TO -->
      <div class="column">
        <div class="columns is-mobile">
          <JourneySummaryAlt
            v-for="(journey, journeyIndex) in solution.journeys"
            :key="journeyIndex"
            :journey="journey"
            :index="journeyIndex"
            class="column is-narrow"
          />
        </div>
      </div>
    </div>

    <div class="columns" style="overflow:auto">
      <div class="column">
        <FareOption :solution="solution" />
      </div>

      <div
        v-for="(upsellItem, upsellIndex) in solution.upsells"
        :key="upsellIndex"
        class="column"
      >
        <FareOption v-if="solution.fareFamily" :solution="upsellItem" />
      </div>
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
import FareOption from "./FareOption.vue";
import JourneySummaryAlt from './JourneySummaryAlt';

export default {
  name: "FareOptionsList",
  mixins: [bookingMixin],
  props: {
    solution: Object,
  },
  components: {
    FareOption,
    JourneySummaryAlt
  },
  data: function() {
    return {
      multiline: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.fare-options-container{
  max-height: calc(100vh - 80px);
  overflow-y: auto;  
}
</style>
